/**
 * Quale componente e quale icona per ogni tipo di widget.
 *
 * Le regole (ruoli, taglie, impostazioni) stanno in src/lib/dashboard/
 * catalogo.ts. Qui c'e' solo la grafica. Il tipo della mappa obbliga ad avere
 * un componente per ogni widget del catalogo: uno dimenticato non compila.
 */

import type { ComponentType } from 'react';
import {
  AlertTriangle,
  BarChart3,
  CalendarClock,
  CalendarDays,
  FileClock,
  FileText,
  PhoneCall,
  PieChart,
  Receipt,
  Repeat,
  Send,
  StickyNote,
  Target,
  UserPlus,
  Users,
  Wallet,
  Zap,
  type LucideIcon,
} from 'lucide-react';
import type { TipoWidget } from '../../../lib/dashboard/catalogo';
import { WidgetBozzeAbbonamenti, WidgetImpegniOggi, WidgetLeadDaRichiamare, WidgetRinnoviAbbonamenti } from './oggi';
import { WidgetAndamentoMensile, WidgetDaIncassare, WidgetFatturato, WidgetFattureScadute, WidgetRicaviRicorrenti } from './soldi';
import { WidgetLeadPerFonte, WidgetNuoviLead, WidgetOfferteAperte, WidgetPipelineLead } from './commerciale';
import { WidgetAzioniRapide, WidgetContattiMailing, WidgetNota, WidgetUltimaCampagna } from './strumenti';
import type { PropsWidget } from './tipi';

export const COMPONENTI_WIDGET: { readonly [T in TipoWidget]: ComponentType<PropsWidget<T>> } = {
  'impegni-oggi': WidgetImpegniOggi,
  'lead-da-richiamare': WidgetLeadDaRichiamare,
  'bozze-abbonamenti': WidgetBozzeAbbonamenti,
  'rinnovi-abbonamenti': WidgetRinnoviAbbonamenti,
  fatturato: WidgetFatturato,
  'da-incassare': WidgetDaIncassare,
  'fatture-scadute': WidgetFattureScadute,
  'andamento-mensile': WidgetAndamentoMensile,
  'ricavi-ricorrenti': WidgetRicaviRicorrenti,
  'nuovi-lead': WidgetNuoviLead,
  'pipeline-lead': WidgetPipelineLead,
  'lead-per-fonte': WidgetLeadPerFonte,
  'offerte-aperte': WidgetOfferteAperte,
  'ultima-campagna': WidgetUltimaCampagna,
  'contatti-mailing': WidgetContattiMailing,
  'azioni-rapide': WidgetAzioniRapide,
  nota: WidgetNota,
};

export const ICONE_WIDGET: Readonly<Record<TipoWidget, LucideIcon>> = {
  'impegni-oggi': CalendarDays,
  'lead-da-richiamare': PhoneCall,
  'bozze-abbonamenti': FileClock,
  'rinnovi-abbonamenti': CalendarClock,
  fatturato: Receipt,
  'da-incassare': Wallet,
  'fatture-scadute': AlertTriangle,
  'andamento-mensile': BarChart3,
  'ricavi-ricorrenti': Repeat,
  'nuovi-lead': UserPlus,
  'pipeline-lead': Target,
  'lead-per-fonte': PieChart,
  'offerte-aperte': FileText,
  'ultima-campagna': Send,
  'contatti-mailing': Users,
  'azioni-rapide': Zap,
  nota: StickyNote,
};
